import {useState} from 'react';

import useReportParameters from '../../../../../hooks/providers/useReportParameters';
import HistoryList from '../HistoryList/HistoryList';
import HistoryModal from '../HistoryModal/HistoryModal';
import ShowAllHistoryButton from '../ShowAllHistoryButton/ShowAllHistoryButton';

const Histories = () => {
  const [isHistoryModalOpen, setIsHistoryModalOpen] = useState(false);

  const {shortRefreshesHistory} = useReportParameters();

  const isShowAllHistoryButtonVisible = shortRefreshesHistory.length >= 5;

  return (
    <>
      <HistoryList histories={shortRefreshesHistory} />

      {isShowAllHistoryButtonVisible && (
        <>
          <ShowAllHistoryButton onClick={() => setIsHistoryModalOpen(true)} />
          <HistoryModal isOpen={isHistoryModalOpen} onClose={() => setIsHistoryModalOpen(false)} />
        </>
      )}
    </>
  );
};

export default Histories;
